import React, { useState, useEffect } from 'react'
import { IonContent, IonPage } from '@ionic/react';
import LayoutGap from '../../layouts/LayoutGap';
import { RouteComponentProps, useHistory } from 'react-router';

import AddComment from '../../components/comment/AddComment';
import Description from './Description';
import Toolbar from '../../layouts/Toolbar';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import Comments from '../comments/Comments';

import './ProductDetailPage.css'
import { ProductCommentsAction } from '../../redux/actions/Shop';

interface Props extends RouteComponentProps<{
    product_id: string,
    type: string
}> { }

const ProductDetailPage: React.FC<Props> = ({ match }) => {
    const history = useHistory();
    const dispatch = useAppDispatch();

    const [title, setTitle] = useState("")
    const [activeComponent, setActiveComponent] = useState(null as any)
    const [addCommentButtonVisible, setAddCommentButtonVisible] = useState(false)
    const [showAddCommentModal, setShowAddCommentModal] = useState(false);


    const { loading1, productComments } = useAppSelector(state => state.productCommentsGet);
    const [comments, setComments] = useState(history.location.state as any);
    const [commentsData, setCommentsData] = useState({ event: null as any, currentPage: 0 });


    const commentsLoadMore = (e: any) => {
        const currentPage = commentsData.currentPage + 1

        setCommentsData({ event: e, currentPage: currentPage })

        dispatch(ProductCommentsAction(match.params.product_id, currentPage))
    }


    useEffect(() => {
        if (productComments != null && !loading1) {
            if (commentsData.event?.target != null) {
                commentsData.event?.target.complete();

                const items = comments.concat(productComments.comments);

                commentsData.event.target.disabled = (items.length == productComments.commentsTotal);

                setComments(items);

                setActiveComponent(<Comments data={items} loadMore={commentsLoadMore} />)
            }
        }
    }, [loading1])


    useEffect(() => {
        if (match.params.type == 'desc') {
            setTitle("توضیحات")
            setActiveComponent(<Description content={history.location.state as any} />)
        } else if (match.params.type == 'comments') {
            setTitle("نظرات")
            setActiveComponent(<Comments data={comments} loadMore={commentsLoadMore} />)
            setAddCommentButtonVisible(true)
        }
    }, [])

    const showCommentHandler = () => {
        // window.addEventListener('popstate', hideCommentHandler);
        setShowAddCommentModal(true);
        // history.push("#add-comment")
    }

    const hideCommentHandler = () => {
        // window.removeEventListener('popstate', hideCommentHandler);
        setShowAddCommentModal(false);
        // if (window.location.hash == "#add-comment") {
        //     history.goBack();
        // }
    }

    return (
        <IonPage className="campaign-detail">
            <Toolbar title={title} hasBackButton />

            <LayoutGap />

            <IonContent className="main-content">
                {activeComponent}
            </IonContent>

            {addCommentButtonVisible ?
                <AddComment id={match.params.product_id} type="product" show={showAddCommentModal} clickShow={showCommentHandler} clickHide={hideCommentHandler} commentPostDone={hideCommentHandler} />
                : null}
        </IonPage>
    )
}

export default ProductDetailPage